export default {
  cards: () => import("/app/layouts/cards.vue").then(m => m.default || m),
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/app/layouts/empty.vue").then(m => m.default || m),
  nft: () => import("/app/layouts/nft.vue").then(m => m.default || m),
  "p2p-main": () => import("/app/layouts/p2p-main.vue").then(m => m.default || m)
}